import { CartErrorEvent, CartLinesUpdateEvent } from '@shopify/events';

/**
 * Adds exactly one selected Shopify bundle-product variant.
 * The product must be configured as a real Shopify Bundle to update child inventories.
 */
class MeluviPdpBundleAdd extends HTMLElement {
  connectedCallback() {
    this.addEventListener('submit', this.onSubmit);
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.onSubmit);
  }

  onSubmit = async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-meluvi-bundle-form]')) return;
    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const message = this.querySelector('.meluvi-pdp-bundle-message');
    const variantId = form.querySelector('input[name="id"]')?.value;
    if (!variantId || button?.disabled) return;

    const root = window.Shopify?.routes?.root || '/';
    const base = root.endsWith('/') ? root : root + '/';
    const sections = Array.from(document.querySelectorAll('cart-items-component'))
      .map((component) => component.dataset.sectionId)
      .filter(Boolean);

    const requestData = new FormData(form);
    if (sections.length) requestData.set('sections', [...new Set(sections)].join(','));
    requestData.set('sections_url', window.location.pathname);

    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: variantId, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (message) {
      message.hidden = true;
      message.textContent = '';
      delete message.dataset.error;
    }

    try {
      const response = await fetch(base + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: requestData,
      });
      const result = await response.json();
      if (!response.ok || result?.status) {
        throw new Error(result?.description || result?.message || 'Nie udało się dodać zestawu do koszyka.');
      }

      const cartResponse = await fetch(base + 'cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!cartResponse.ok) throw new Error('Nie udało się odświeżyć koszyka.');
      const cart = await cartResponse.json();
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          sections: result.sections,
          source: 'meluvi-pdp-bundle',
          didError: false,
        },
      });

      if (message) {
        message.textContent = 'Zestaw dodany do koszyka.';
        message.hidden = false;
      }

      if (!document.getElementById('cart-drawer')) {
        window.location.assign(base + 'cart');
      }
    } catch (error) {
      deferred.reject(error);
      this.dispatchEvent(new CartErrorEvent({
        error: error?.message || 'Nie udało się dodać zestawu.',
        code: 'INVALID',
      }));
      if (message) {
        message.textContent = error?.message || 'Nie udało się dodać zestawu.';
        message.dataset.error = 'true';
        message.hidden = false;
      }
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('meluvi-pdp-bundle-add')) {
  customElements.define('meluvi-pdp-bundle-add', MeluviPdpBundleAdd);
}